import React from 'react';
import { Package, Brain, Zap, TrendingUp, BookOpen } from 'lucide-react';
export function ProductContents() {
  return <section className="py-8 md:py-12 bg-navy-900" data-id="element-85">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-86">
        {/* Lo que vas a recibir */}
        <div className="mb-8 md:mb-12" data-id="element-87">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-white mb-4 md:mb-6 flex items-center gap-2 md:gap-3" data-id="element-88">
            <Package className="w-6 h-6 md:w-7 md:h-7 text-gold-400" data-id="element-89" />
            Lo que vas a recibir
          </h2>
          <div className="bg-navy-800 rounded-xl p-4 md:p-6 border border-navy-700" data-id="element-90">
            <p className="text-sm md:text-base text-slate-300 mb-3 md:mb-4" data-id="element-91">
              Dentro de Charter Command System™ vas a encontrar:
            </p>
            <div className="grid sm:grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-4" data-id="element-92">
              <div className="flex items-center gap-2 text-white bg-navy-900 p-2 md:p-3 rounded-lg text-xs md:text-sm" data-id="element-93">
                <span className="text-green-400 font-bold" data-id="element-94">✔</span> Checklists
                listos para usar
              </div>
              <div className="flex items-center gap-2 text-white bg-navy-900 p-2 md:p-3 rounded-lg text-xs md:text-sm" data-id="element-95">
                <span className="text-green-400 font-bold" data-id="element-96">✔</span> Plantillas
                profesionales
              </div>
              <div className="flex items-center gap-2 text-white bg-navy-900 p-2 md:p-3 rounded-lg text-xs md:text-sm" data-id="element-97">
                <span className="text-green-400 font-bold" data-id="element-98">✔</span> Scripts de
                comunicación claros
              </div>
              <div className="flex items-center gap-2 text-white bg-navy-900 p-2 md:p-3 rounded-lg text-xs md:text-sm" data-id="element-99">
                <span className="text-green-400 font-bold" data-id="element-100">✔</span> Sistema de
                control diario
              </div>
              <div className="flex items-center gap-2 text-white bg-navy-900 p-2 md:p-3 rounded-lg text-xs md:text-sm sm:col-span-2" data-id="element-101">
                <span className="text-green-400 font-bold" data-id="element-102">✔</span> Estructura
                completa de operación
              </div>
            </div>
            <p className="text-center text-gold-400 font-medium text-sm md:text-base" data-id="element-103">
              Todo diseñado para que no tengas que inventar nada.
            </p>
          </div>
        </div>

        {/* Resultados en 7 días */}
        <div className="mb-8 md:mb-12" data-id="element-104">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-white mb-4 md:mb-6 flex items-center gap-2 md:gap-3" data-id="element-105">
            <Zap className="w-6 h-6 md:w-7 md:h-7 text-gold-400" data-id="element-106" />
            Lo que podés lograr en menos de 7 días
          </h2>
          <div className="bg-gradient-to-br from-navy-800 to-navy-900 p-4 md:p-6 rounded-xl border border-navy-700" data-id="element-107">
            <p className="text-sm md:text-base text-slate-300 mb-3 md:mb-4" data-id="element-108">
              En menos de una semana podés:
            </p>
            <ul className="space-y-1.5 md:space-y-2 mb-4 md:mb-6" data-id="element-109">
              <li className="flex items-center gap-2 text-white text-sm md:text-base" data-id="element-110">
                <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-gold-500 rounded-full" data-id="element-111"></div>{' '}
                Ordenar completamente tu operación
              </li>
              <li className="flex items-center gap-2 text-white text-sm md:text-base" data-id="element-112">
                <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-gold-500 rounded-full" data-id="element-113"></div>{' '}
                Reducir errores drásticamente
              </li>
              <li className="flex items-center gap-2 text-white text-sm md:text-base" data-id="element-114">
                <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-gold-500 rounded-full" data-id="element-115"></div>{' '}
                Mejorar la coordinación del equipo
              </li>
              <li className="flex items-center gap-2 text-white text-sm md:text-base" data-id="element-116">
                <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-gold-500 rounded-full" data-id="element-117"></div>{' '}
                Tener control real sin estar encima de todo
              </li>
              <li className="flex items-center gap-2 text-white text-sm md:text-base" data-id="element-118">
                <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-gold-500 rounded-full" data-id="element-119"></div>{' '}
                Elevar la experiencia del cliente
              </li>
            </ul>
            <div className="flex flex-col sm:flex-row gap-2 md:gap-3 justify-center" data-id="element-120">
              <span className="bg-navy-950 px-3 py-1.5 rounded-lg text-slate-300 text-center text-xs font-medium" data-id="element-121">
                👉 Sin cambiar tu tripulación
              </span>
              <span className="bg-navy-950 px-3 py-1.5 rounded-lg text-slate-300 text-center text-xs font-medium" data-id="element-122">
                👉 Sin trabajar más
              </span>
              <span className="bg-navy-950 px-3 py-1.5 rounded-lg text-slate-300 text-center text-xs font-medium" data-id="element-123">
                👉 Sin depender de la improvisación
              </span>
            </div>
          </div>
        </div>

        {/* Resultados a largo plazo */}
        <div className="mb-8 md:mb-12" data-id="element-124">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-white mb-4 md:mb-6 flex items-center gap-2 md:gap-3" data-id="element-125">
            <TrendingUp className="w-6 h-6 md:w-7 md:h-7 text-gold-400" data-id="element-126" />
            Resultados que vas a empezar a notar
          </h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-127">
            {['Menos problemas diarios', 'Más claridad en cada rol', 'Mejor ambiente a bordo', 'Mayor profesionalismo', 'Clientes más satisfechos', 'Más tranquilidad para vos'].map((res, i) => <div key={i} className="bg-navy-800 p-2 md:p-3 rounded-xl border border-navy-700 text-center text-slate-200 text-xs md:text-sm" data-id="element-128">
                {res}
              </div>)}
          </div>
          <div className="text-center bg-gold-500/10 border border-gold-500/30 p-3 md:p-4 rounded-xl" data-id="element-129">
            <p className="text-slate-300 mb-1 text-xs md:text-sm" data-id="element-130">
              Y el más importante:
            </p>
            <p className="text-lg md:text-2xl font-bold text-white" data-id="element-131">
              👉 Dejar de sobrevivir… y empezar a dirigir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}